import { Routes, Route, Navigate } from 'react-router-dom';
import PollPage from './components/PollPage';
import ResultsPage from './components/ResultsPage';
import WebResultsPage from './components/WebResultsPage';
import PrintResultsPage from './components/PrintResultsPage';
import CorrelationsIndexPage from './components/correlations/CorrelationsIndexPage';
import CorrelationsPage from './components/correlations/CorrelationsPage';
import { APP_CONFIG } from './config/settings';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<PollPage />} />
        <Route path="/poll" element={<PollPage />} />
        <Route path="/poll/:lang" element={<PollPage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route
          path="/web"
          element={
            <Navigate to={`/web/${APP_CONFIG.DEFAULT_LANGUAGE}`} replace />
          }
        />
        <Route path="/web/:lang" element={<WebResultsPage />} />
        <Route path="/print" element={<PrintResultsPage />} />
        <Route path="/correlations" element={<CorrelationsIndexPage />} />
        <Route path="/correlations/:num" element={<CorrelationsPage />} />
      </Routes>
    </div>
  );
}

export default App;
